import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetService {
  private resetSubject = new Subject<void>();

  get reset$() {
    return this.resetSubject.asObservable();
  }

  triggerReset() {
    this.resetSubject.next();
  }
}